import { z } from 'zod';
import { FITS } from '../constants.ts';
import { idSchema, unixMsSchema } from './common.ts';

export const fitSchema = z.enum(FITS);

export const playlistItemSchema = z.object({
  id: idSchema,
  playlist_id: idSchema,
  media_id: idSchema,
  duration_ms: z.number().int().positive(),
  position: z.number().int().nonnegative(),
  fit: fitSchema,
});
export type PlaylistItem = z.infer<typeof playlistItemSchema>;

export const playlistSchema = z.object({
  id: idSchema,
  org_id: idSchema,
  name: z.string().min(1),
  created_at: unixMsSchema,
  updated_at: unixMsSchema,
});
export type Playlist = z.infer<typeof playlistSchema>;

export const playlistWithItemsSchema = playlistSchema.extend({
  items: z.array(playlistItemSchema),
});
export type PlaylistWithItems = z.infer<typeof playlistWithItemsSchema>;

export const createPlaylistSchema = z.object({
  name: z.string().min(1),
});
export type CreatePlaylist = z.infer<typeof createPlaylistSchema>;

export const updatePlaylistSchema = createPlaylistSchema.partial();
export type UpdatePlaylist = z.infer<typeof updatePlaylistSchema>;

// PUT /v1/playlists/:id/items — full replace (docs/03: "simplest correct model").
export const setPlaylistItemsSchema = z.object({
  items: z.array(
    z.object({
      media_id: idSchema,
      duration_ms: z.number().int().positive(),
      fit: fitSchema.default('contain'),
    }),
  ),
});
export type SetPlaylistItems = z.infer<typeof setPlaylistItemsSchema>;

// POST /v1/playlists/bulk-add — append the given media (default duration each) to the
// END of every listed playlist (Sprint 4). All-or-nothing: every id is validated first.
export const bulkAddPlaylistsSchema = z.object({
  media_ids: z.array(idSchema).min(1),
  playlist_ids: z.array(idSchema).min(1),
});
export type BulkAddPlaylists = z.infer<typeof bulkAddPlaylistsSchema>;

export const bulkAddResultSchema = z.object({
  playlist_id: idSchema,
  added: z.number().int().nonnegative(),
});
export type BulkAddResult = z.infer<typeof bulkAddResultSchema>;
